export const environment = {
  production: true,
  sentry_env: 'production',
  bamboo_build_nr:"90"
};
